import { render, staticRenderFns } from "./deliver_goods_dialog.vue?vue&type=template&id=479ede5e"
import script from "./deliver_goods_dialog.vue?vue&type=script&lang=js"
export * from "./deliver_goods_dialog.vue?vue&type=script&lang=js"
import style0 from "./deliver_goods_dialog.vue?vue&type=style&index=0&id=479ede5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports